import { useEffect } from "react";
import { Phone } from "lucide-react";
import ServiceHeader from "@/components/ServiceHeader";
import Footer from "@/components/Footer";
import StickyCallButton from "@/components/StickyCallButton";

const ComingSoonLocation = ({ city, slug }: { city: string; slug: string }) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${city} Removalists - Coming Soon | OZ MOVE CO.`;
    const desc = document.head.querySelector<HTMLMetaElement>('meta[name="description"]');
    const prevDesc = desc?.getAttribute("content") ?? "";
    desc?.setAttribute(
      "content",
      `OZ MOVE CO. is expanding to ${city}. Contact our team to check availability or discuss your upcoming move.`,
    );
    const canonical = document.querySelector('link[rel="canonical"]');
    const prevCanonical = canonical?.getAttribute("href") ?? "";
    canonical?.setAttribute("href", `https://ozmoveco.com.au/${slug}`);
    window.scrollTo(0, 0);
    return () => {
      document.title = prevTitle;
      desc?.setAttribute("content", prevDesc);
      if (canonical) canonical.setAttribute("href", prevCanonical);
    };
  }, [city, slug]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <ServiceHeader />
      <main className="flex-1 bg-[#FFC300] relative overflow-hidden flex items-center">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_25%_20%,rgba(255,255,255,0.55),transparent_55%)]" aria-hidden="true" />
        <div className="container relative py-24 md:py-36">
          <div className="max-w-2xl mx-auto text-center bg-white/60 backdrop-blur-xl border border-white/60 shadow-[0_8px_40px_rgba(26,26,26,0.08)] rounded-3xl px-6 py-12 md:px-12 md:py-16">
            <h1 className="text-4xl md:text-5xl font-black text-[#1a1a1a] tracking-tight leading-tight">
              {city} - Coming to Your Area Soon
            </h1>
            <p className="mt-6 text-lg text-[#1a1a1a]/75 leading-relaxed">
              We're expanding across Australia and look forward to servicing your area soon. In the
              meantime, contact our team to check availability or discuss your move.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/#quote"
                className="bg-[#1a1a1a] text-[#FFC300] px-8 py-4 text-lg font-bold rounded-xl hover:opacity-90 transition-opacity"
              >
                Get Free Quote
              </a>
              <a
                href="tel:1800556654"
                aria-label="Call 1800 556 654"
                className="inline-flex items-center justify-center gap-2 border-2 border-[#1a1a1a] text-[#1a1a1a] px-8 py-4 text-lg font-bold rounded-xl hover:bg-[#1a1a1a]/5 transition-colors"
              >
                <Phone className="w-5 h-5" /> Call Now
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <StickyCallButton />
    </div>
  );
};

export default ComingSoonLocation;
